export const identityVerification = {
  pageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf: business details: id number',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),

  formStart: () => ({
    event_name: 'form_start',
    page_name: 'vodapay: business advance: opf: business details: id number',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: business representative details: identity verification'
  }),

  formEnd: (identityType) => ({
    event_name: 'form_end',
    page_name: 'vodapay: business advance: opf: business details: id number',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business advance: opf: business representative details: identity verification',
    identity_type: identityType,
    link_id: `vodapay: business advance: opf: ${identityType}: next`
  })
};